import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Link as MuiLink,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { frontendRoutes } from "../../../utility/frontendRoutes";
import { landingColors } from "../landingColors";
import { IOS_STORE_URL, ANDROID_STORE_URL } from "../../../utility/constants";
import { faqs } from "../data/faqData";
import SectionContainer from "./SectionContainer";

const GetStartedAnswer = () => (
  <Typography sx={{ color: landingColors.textSecondary }}>
    Download the app on the{" "}
    <MuiLink
      href={IOS_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ fontWeight: 600 }}
    >
      App Store
    </MuiLink>{" "}
    or{" "}
    <MuiLink
      href={ANDROID_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ fontWeight: 600 }}
    >
      Google Play
    </MuiLink>{" "}
    to sign up. You'll need an active phone number to create an account, and you
    can sign in with your phone number and password or continue with Google.
    Prefer to browse first? Check out{" "}
    <MuiLink
      component={RouterLink}
      to={frontendRoutes.HOME}
      sx={{ fontWeight: 600 }}
    >
      the marketplace
    </MuiLink>{" "}
    on the web anytime.
  </Typography>
);

const FaqSection = () => (
  <SectionContainer id="faq">
    <Box sx={{ textAlign: "center", mb: { xs: 5, md: 6 } }}>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 800,
          color: landingColors.textPrimary,
          fontSize: { xs: 28, md: 40 },
        }}
      >
        Frequently Asked Questions
      </Typography>
      <Typography sx={{ color: landingColors.textSecondary, mt: 1.5 }}>
        Answers to common questions from buyers and sellers, all in one place.
      </Typography>
    </Box>

    <Box sx={{ maxWidth: { xs: 720, md: 880 }, mx: "auto" }}>
      {faqs.map((faq, i) => (
        <Accordion
          key={faq.q}
          disableGutters
          elevation={0}
          defaultExpanded={i === 0}
          sx={{
            bgcolor: landingColors.surface,
            boxShadow: landingColors.cardShadow,
            border: `1px solid ${landingColors.border}`,
            borderRadius: "12px !important",
            mb: 1.5,
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography
              fontWeight={700}
              sx={{ color: landingColors.textPrimary }}
            >
              {faq.q}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {faq.id === "get-started" ? (
              <GetStartedAnswer />
            ) : (
              <Typography sx={{ color: landingColors.textSecondary }}>
                {faq.a}
              </Typography>
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>

    <Typography
      sx={{ textAlign: "center", color: landingColors.textSecondary, mt: 3 }}
    >
      Have a different question?{" "}
      <MuiLink
        component={RouterLink}
        to={frontendRoutes.HELP}
        sx={{ fontWeight: 600 }}
      >
        Visit our Help Center
      </MuiLink>{" "}
      for step-by-step guides.
    </Typography>
  </SectionContainer>
);

export default FaqSection;
